import { ItemBadge } from '@liveauctioneers/hammer-ui-core/badge/ItemBadge';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import ItemCardBadge from '@/components/GridItemCard/Card/components/ItemCardBadge/ItemCardBadge';
import { useAppSelector } from '@/redux/hooks';
import {
    getItemSummaryIsExtended,
    getItemSummaryIsPassed,
    getItemSummaryIsPaused,
    getItemSummaryIsSold,
    getItemSummaryIsTimedPlusAuction,
} from '@/redux/modules/item/summary/itemSummary.selectors';

export type TimedBadgeContainerProps = {
    // If on a larger item image (e.g. the main image on the item page), we have a 16px on the top and left.
    // Otherwise, we have 9px.
    itemId: number;
};

const TimedBadgeContainer = ({ itemId }: TimedBadgeContainerProps) => {
    const isSold = useAppSelector((state) => getItemSummaryIsSold(state, itemId));
    const isPassed = useAppSelector((state) => getItemSummaryIsPassed(state, itemId));
    const isPaused = useAppSelector((state) => getItemSummaryIsPaused(state, itemId));
    const isTimedPlus = useAppSelector((state) => getItemSummaryIsTimedPlusAuction(state, itemId));
    const isExtended = useAppSelector((state) => getItemSummaryIsExtended(state, itemId));

    if (!isSold && !isPassed && !isPaused && isTimedPlus && isExtended) {
        return (
            <ItemBadge
                className={cn('absolute left-xs top-xs z-[1]', 'animate-pulse')}
                isExtended
            />
        );
    }

    return (
        <div
            className="absolute left-xs top-xs z-[1]"
            data-testid="timed-badge"
        >
            <ItemCardBadge itemId={itemId} />
        </div>
    );
};

export default TimedBadgeContainer;
